//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UploadFile from "components/UploadFile.vue";
import imageUpload from "components/imageUpload.vue";
export default {
  data: function data() {
    return {
      Name: "",
      Logo: "",
      Introduce: "",
      url: "/api/XOrg/AssociationIndex/getSign",
      files: [],
      fileList: [],
      urlAliyunOSS: "/api/XOrg/AssociationIndex/getSign",
      MedalIconUrl: "",
      AvatorUrl: ""
    };
  },
  computed: {
    userInfo: function userInfo() {
      return this.$store.state.auth;
    }
  },
  components: {
    UploadFile: UploadFile,
    imageUpload: imageUpload
  },
  created: function created() {
    this.getInfo();
  },
  watch: {
    AvatorUrl: function AvatorUrl(val) {
      console.log(val);
    }
  },
  methods: {
    getInfo: function getInfo() {
      var that = this;
      this.$http.post("/api/XOrg/AOrgInfo/getInfo", {}).then(function (rst) {
        if (rst.code === 1 && rst.associationInfo) {
          that.Name = rst.associationInfo.Name;
          that.Logo = rst.associationInfo.Logo;
          that.Introduce = rst.associationInfo.Introduce;
        } else {
          that.$message.warning(rst.msg || "");
        }
      });
    },
    updateAssociation: function updateAssociation() {
      var that = this;
      this.$http.post("/api/XOrg/AOrgInfo/updateAssociation", {
        logoUrl: that.Logo,
        Introduce: that.Introduce
      }).then(function (rst) {
        if (rst.code === 1) {
          that.$message.success(rst.msg);
        } else {
          that.$message.warning(rst.msg);
        }
      });
    }
  }
};